(function () {
  'use strict';

  var config = window.RRZeroBounceConfig || {};
  var validationEnabled = Boolean(config.enabled);
  var proxyUrl = sanitizeProxyUrl(config.proxyUrl);
  if (!validationEnabled) return;

  var TIMEOUT_MS = Number(config.timeoutMs) > 0 ? Number(config.timeoutMs) : 4500;
  var INVALID_STATUSES = ['invalid', 'spamtrap', 'abuse', 'do_not_mail'];
  var EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var validationCache = Object.create(null);

  function sanitizeProxyUrl(rawValue) {
    var value = String(rawValue || '').trim();
    if (!value) return '';

    // Refuse to run if the configured URL appears to include credentials.
    if (/(?:api[_-]?key|token|secret)=/i.test(value)) return '';

    value = value.split('?')[0].split('#')[0];
    if (!value) return '';

    try {
      var url = new URL(value, window.location.origin);
      var isSecure = url.protocol === 'https:';
      var isLocalHttp =
        url.protocol === 'http:' &&
        (url.hostname === 'localhost' || url.hostname === '127.0.0.1');
      if (!isSecure && !isLocalHttp) return '';
      return url.toString();
    } catch (error) {
      return '';
    }
  }

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function getEmailInputs(form) {
    if (!form) return [];

    var directInputs = Array.prototype.slice.call(
      form.querySelectorAll('input[type="email"]:not([type="hidden"])')
    );
    var namedInputs = Array.prototype.slice.call(
      form.querySelectorAll('input[name*="email" i]:not([type="hidden"])')
    );
    var all = directInputs.concat(namedInputs);
    var deduped = [];
    var seen = [];

    for (var i = 0; i < all.length; i += 1) {
      var input = all[i];
      if (!input || input.disabled || input.readOnly) continue;
      if (seen.indexOf(input) !== -1) continue;
      seen.push(input);
      deduped.push(input);
    }

    return deduped;
  }

  function collectEmails(form) {
    var inputs = getEmailInputs(form);
    var results = [];

    for (var i = 0; i < inputs.length; i += 1) {
      var input = inputs[i];
      var email = normalize(input.value);
      if (!email) continue;
      results.push({ input: input, email: email });
    }

    return results;
  }

  function clearError(form) {
    if (!form) return;
    form.querySelectorAll('.zerobounce-form-error').forEach(function (node) {
      node.remove();
    });
    getEmailInputs(form).forEach(function (input) {
      if (!input) return;
      input.removeAttribute('aria-describedby');
    });
  }

  function clearSuccessState(form) {
    if (!form) return;

    form
      .querySelectorAll('.form-status.form-status-list.form__message, .form-status-list.caption-large')
      .forEach(function (node) {
        node.remove();
      });
  }

  function showError(form, input, message) {
    if (!form || !input) return;
    clearSuccessState(form);
    clearError(form);

    var error = document.createElement('div');
    var errorId =
      'zerobounce-error-' +
      Math.random()
        .toString(36)
        .slice(2, 10);
    error.className = 'form__message zerobounce-form-error';
    error.id = errorId;
    error.setAttribute('role', 'alert');
    error.setAttribute('aria-live', 'polite');
    error.textContent = message;

    var field = input.closest('.field');
    if (field) {
      field.appendChild(error);
    } else {
      var anchor = input.parentElement || form;
      anchor.insertAdjacentElement('beforeend', error);
    }

    input.setAttribute('aria-invalid', 'true');
    input.setAttribute('aria-describedby', errorId);
    input.focus();
  }

  function setSubmittingState(form, disabled) {
    if (!form) return;
    form.querySelectorAll('button[type="submit"], input[type="submit"]').forEach(function (button) {
      button.disabled = disabled;
    });
  }

  async function validateEmail(email) {
    if (validationCache[email]) return validationCache[email];

    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timeoutId = null;
    if (controller) {
      timeoutId = window.setTimeout(function () {
        controller.abort();
      }, TIMEOUT_MS);
    }

    try {
      var response = await fetch(proxyUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email }),
        signal: controller ? controller.signal : undefined,
      });

      if (!response.ok) {
        throw new Error('ZeroBounce proxy request failed');
      }

      var payload = await response.json();
      validationCache[email] = payload || {};
      return validationCache[email];
    } finally {
      if (timeoutId) window.clearTimeout(timeoutId);
    }
  }

  function isRejected(payload) {
    var status = normalize(payload && payload.status);
    var subStatus = normalize(payload && payload.sub_status);

    if (INVALID_STATUSES.indexOf(status) !== -1) return true;
    if (subStatus.indexOf('disposable') !== -1) return true;
    return false;
  }

  function buildInvalidMessage(payload) {
    var suggestion = String((payload && payload.did_you_mean) || '').trim();
    if (suggestion) {
      return 'This email looks invalid. Did you mean ' + suggestion + '?';
    }
    return 'Please enter a valid email address before submitting.';
  }

  function submitForm(form, submitter) {
    if (form && typeof form.requestSubmit === 'function') {
      if (submitter && submitter.form === form) {
        form.requestSubmit(submitter);
        return;
      }
      form.requestSubmit();
      return;
    }

    form.submit();
  }

  async function handleSubmit(event) {
    var form = event.target;
    if (!form || !form.matches) return;
    if (form.hasAttribute('data-zb-ignore')) return;
    if (form.dataset.zbBypass === '1') return;

    var emailEntries = collectEmails(form);
    if (!emailEntries.length) return;

    var signature = emailEntries
      .map(function (entry) {
        return entry.email;
      })
      .join('|');
    if (signature && form.dataset.zbValidatedEmail === signature) return;

    event.preventDefault();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    if (event.stopPropagation) event.stopPropagation();
    clearError(form);
    emailEntries.forEach(function (entry) {
      entry.input.removeAttribute('aria-invalid');
    });
    setSubmittingState(form, true);

    try {
      if (!proxyUrl) {
        showError(
          form,
          emailEntries[0].input,
          'Email verification is temporarily unavailable. Please try again in a moment.'
        );
        return;
      }

      for (var i = 0; i < emailEntries.length; i += 1) {
        var entry = emailEntries[i];
        if (!EMAIL_REGEX.test(entry.email)) {
          showError(form, entry.input, 'Please enter a valid email address before submitting.');
          return;
        }

        var result = await validateEmail(entry.email);
        if (isRejected(result)) {
          showError(form, entry.input, buildInvalidMessage(result));
          return;
        }
      }

      if (signature) {
        form.dataset.zbValidatedEmail = signature;
      }
      form.dataset.zbBypass = '1';
      submitForm(form, event.submitter);
    } catch (error) {
      // Fail closed to enforce verification on all email collection forms.
      showError(
        form,
        emailEntries[0].input,
        'Email verification is temporarily unavailable. Please try again in a moment.'
      );
    } finally {
      setSubmittingState(form, false);
      if (form.dataset.zbBypass === '1') {
        window.setTimeout(function () {
          form.dataset.zbBypass = '0';
        }, 0);
      }
    }
  }

  document.addEventListener(
    'submit',
    function (event) {
      handleSubmit(event);
    },
    true
  );
})();
